import { Link } from 'react-router-dom';
import { categoryCards } from '@/mocks/homepage';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12 md:mb-16">
          <div>
            <span className="text-foreground-400 text-xs tracking-widest uppercase font-medium font-heading">
              分类浏览
            </span>
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-black text-foreground-900 font-heading leading-tight mt-2">
              吃瓜<span className="italic font-light text-foreground-400">分类</span>
            </h2>
          </div>
          <p className="text-foreground-500 text-sm max-w-md leading-relaxed">
            按分类浏览你最感兴趣的爆料内容，从网红塌房到选秀黑幕，总有一款适合你
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {categoryCards.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group rounded-2xl overflow-hidden cursor-pointer transition-all duration-300 hover:scale-[1.02]"
            >
              <div className={`aspect-[3/4] relative ${cat.color}`}>
                <img
                  src={cat.imageUrl}
                  alt={cat.title}
                  title={cat.title}
                  className="w-full h-[85%] object-cover object-top"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-background-50 px-4 py-3.5">
                  <h3 className="text-foreground-900 font-bold text-sm md:text-base font-heading">
                    {cat.title}
                  </h3>
                  <p className="text-foreground-500 text-xs mt-0.5">
                    {cat.description}
                  </p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}